import { Box, DropButton } from 'grommet';
import { Calculator } from 'grommet-icons';
import { useState } from 'react';
import { QuickEstimatorPanel } from './QuickEstimatorPanel';

export const QuickEstimatorMenu = () => {
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <DropButton
      icon={
        <Box width="24px" height="24px" align="center">
          <Calculator size={isMouseOver ? '24' : '20'} color="white" />
        </Box>
      }
      onMouseOver={() => setIsMouseOver(true)}
      onMouseOut={() => setIsMouseOver(false)}
      tip="Quick Estimator"
      dropContent={<QuickEstimatorPanel />}
      dropAlign={{ top: 'bottom', right: 'right' }}
    />
  );
};
